import base from '@/http/url_base';

export default {
  TRANSFERT: base.API_GPAO + '/transferts',
  GET_DEMANDES: base.API_GPAO + '/transferts/demandes',
  GET_DEMANDE_ARTICLES: base.API_GPAO + '/transferts/demande/articles',
  GET_REQUIREMENTS: base.API_GPAO + '/transferts/requirements',
};
